@if (fixLink) {
  <iframe [src]="fixLink" frameborder="0" style="height: 70vh"></iframe>
}
<div class="buttons">
  <app-button buttonText="gate_faults.repair_modal.cancel" (click)="cancel()"></app-button>
  @if (
    (!repairStatus || repairStatus === REPAIR_STATUS.None || repairStatus === REPAIR_STATUS.Archived) &&
    permissions.hasPermission(permissions.allPermissions.REPAIR_REQUEST_CREATE)
  ) {
    <app-button buttonText="gate_faults.repair_modal.request" (click)="request()"></app-button>
    <app-button buttonText="gate_faults.repair_modal.no_request" (click)="noRequest()"></app-button>
  }
</div>
